module.exports = __webpack_public_path__ + "img/manual@2x.05179b58.png";